import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    FormInput,
    FormCheckbox,
    Button,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import {requestProfilPatient, requestConsultationsPatient, updatePatientData} from "../../actions/patients.action";
import {resetPasswordUser} from "../../actions/users.action";
import { connect } from "react-redux";
import dateFormat from "dateformat";
import { searchConsultationsPatients } from "../../actions/consultations.action";
import { createSlot } from "../../actions/premium.action";
import {ConsultationTable} from "../../components/tables/ConsultationTable";
import CopyText from "../../components/form/CopyText";

class Profil extends React.Component
{
    constructor(props) {
        super(props);
        let id = this.props.match.params.id;
        this.props.loadProfil(id);
        this.props.loadConsultations(id);
        this.state = {
            email: '',
            phone: ''
        }
        this.resetPasswordUser = this.resetPasswordUser.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setRestricted = this.setRestricted.bind(this);
    }

    componentDidMount() {
        this.setState({
            email: this.props.patients.data.email,
            phone: this.props.patients.data.phone,
        })
    }

    setRestricted(event) {
        event.preventDefault();
        if (!this.props.patients.loading) {
            let payload = {
                id: this.props.patients.data.id,
                restricted: !this.props.patients.data.is_restricted
            };
            this.props.updatePatient(payload);
        }
    }
    updateDetails = () => {
        if (!this.props.users.loading) {
            let payload = {
                id: this.props.patients.data.id,
                phone: this.state.phone,
                email: this.state.email,
            };

            this.props.updatePatient(payload);
        }
    }
    handleChange(event) {
        let name = event.target.name;
        this.setState({ [name] : event.target.value});
    }
    resetPasswordUser(event) {
        event.preventDefault();
        if (!this.props.users.loading){
            let payload = {
                id: this.props.patients.data.id
            };
            this.props.resetPassword(payload);
        }
    }


    render() {
        return (
            <Container fluid className="main-content-container px-4">
                {this.props.consultations.fetching || this.props.patients.fetching ? (

                    <div className="flex-center">
                        <div className="text-center d-block">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                <div>
                    <Row noGutters className="page-header pt-4">
                        <PageTitle
                          title={this.props.patients.data.first_name + ' ' + this.props.patients.data.last_name}
                          subtitle="Profil" className="text-sm-left mb-3"/>
                    </Row>
                    <Row>
                        <Col lg="12" className="mx-auto mt-4">
                            <Row>
                                <Col lg="4" className="mx-auto">
                                    <Card small className="edit-user-details mb-4">
                                        <CardHeader className="border-bottom">
                                            <Row>
                                                <Col md="6">
                                                    <h6 className="m-0">Détails</h6>
                                                </Col>
                                                <Col md="6" className="text-right">
                                                    <Button
                                                      className="block-center"
                                                      disabled={this.props.users.loading}
                                                      onClick={() => this.updateDetails()}>
                                                        Enregistrer
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        <CardBody>
                                            <Row className="m-0">
                                                <Col md="6" className="form-group">
                                                    <label htmlFor="lastName">Nom</label>
                                                    <FormInput
                                                      type="text"
                                                      defaultValue={this.props.patients.data.last_name}
                                                      disabled
                                                    />
                                                </Col>
                                                <Col md="6" className="form-group">
                                                    <label>Prénom</label>
                                                    <FormInput
                                                      defaultValue={this.props.patients.data.first_name}
                                                      disabled
                                                    />
                                                </Col>
                                                <Col md="12" className="form-group">
                                                    <label htmlFor="phoneNumber">Téléphone</label>
                                                    <InputGroup seamless>
                                                        <InputGroupAddon type="prepend">
                                                            <InputGroupText>
                                                                <i className="material-icons practitioner-color">&#xE0CD;</i>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <FormInput
                                                          name="phone"
                                                          defaultValue={this.props.patients.data.phone}
                                                          onChange={this.handleChange}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col md="12" className="form-group">
                                                    <label htmlFor="emailAddress">Email</label>
                                                    <InputGroup seamless>
                                                        <InputGroupAddon type="prepend">
                                                            <InputGroupText>
                                                                <i className="material-icons practitioner-color">&#xE0BE;</i>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <FormInput
                                                          name="email"
                                                          defaultValue={this.props.patients.data.email}
                                                          onChange={this.handleChange}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col md="12" className="form-group">
                                                    <label>Identifiant technique</label>
                                                    <CopyText
                                                        text={this.props.patients.data.id}
                                                    />
                                                </Col>
                                                <Col md="6" className="form-group">
                                                    <label htmlFor="lastName">Date d'inscription</label>
                                                    <InputGroup seamless>
                                                        <InputGroupAddon type="prepend">
                                                            <InputGroupText>
                                                                <i className="material-icons">calendar_today</i>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <FormInput
                                                            value={this.props.patients.data.created_at && dateFormat(new Date(this.props.patients.data.created_at), "dd/mm/yyyy")}
                                                            disabled
                                                        />
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                            <Row className="m-0">
                                                <Col md="4" className="form-group">
                                                    <Form >
                                                        <FormGroup>
                                                            <label>Contacts facturation</label>
                                                            <InputGroup>
                                                                <FormInput
                                                                    type="email"
                                                                />
                                                                <InputGroupAddon type="append">
                                                                    <Button type="submit"
                                                                            outline>Ajouter</Button>
                                                                </InputGroupAddon>
                                                            </InputGroup>
                                                        </FormGroup>
                                                        <ul className="contact_facturation_list">

                                                                    <li>
                                                                        <span
                                                                            onClick={this.removeContact}><i
                                                                            className="material-icons remove_contact">cancel</i></span>
                                                                    </li>

                                                        </ul>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    <Card small className="edit-user-details mt-3">
                                        <CardHeader className="border-bottom">
                                            <Row>
                                                <Col md="12">
                                                    <h6 className="m-0">Réinitialiser le mot de passe</h6>
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        <CardBody>
                                            <Row className="m-0">
                                                <Col md="12" className="form-group center">
                                                    <Button
                                                      className="block-center"
                                                      disabled={this.props.users.loading}
                                                      onClick={this.resetPasswordUser}>
                                                        Générer un nouveau lien
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Col md="12" className="form-group">
                                                <label htmlFor="lastName">Lien</label>
                                                <CopyText
                                                  text={this.props.users.data.token}
                                                />
                                            </Col>
                                        </CardBody>
                                    </Card>
                                    <Card small className="edit-user-details mt-3">
                                        <CardHeader className="border-bottom">
                                            <Col md="12">
                                                <h6 className="m-0">Rôles utilisateur</h6>
                                            </Col>
                                        </CardHeader>
                                        <CardBody>
                                            <Row className="mb-3">
                                                <Col className="d-flex status-profil">
                                                    <FormCheckbox
                                                        toggle
                                                        disabled={this.props.patients.loading}
                                                        className="my-auto"
                                                        checked={this.props.patients.data.is_restricted}
                                                        onChange={this.setRestricted}
                                                    >
                                                        Rôle Restreint
                                                    </FormCheckbox>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>

                                </Col>
                                <Col lg="8" className="mx-auto">
                                    <ConsultationTable
                                        parent={'patients'}
                                        research={this.props.consultations.searching}
                                        dataSearch={searchConsultationsPatients}
                                        entity={'patient'}
                                        selected={this.props.patients.data.id}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                )}
            </Container>
        );
    }
}

function mapStateToProps(state)
{
    return {
        patients: state['patients'],
        users: state['users'],
        consultations: state['consultations']
    };
}

const mapDispatchToProps = dispatch => ({
    loadProfil: (e) => dispatch(requestProfilPatient(e)),
    loadConsultations: (e) => dispatch(requestConsultationsPatient(e)),
    resetPassword: (e) => dispatch(resetPasswordUser(e)),
    updatePatient: (e) => dispatch(updatePatientData(e)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profil);



// WEBPACK FOOTER //
// ./src/views/Patients/Profil.js